var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8 27.2L57.7.3h-15l.1 26.9 7.5 10.3 7.5-10.3zm-15 46.1v27h15v-27L50.3 63l-7.5 10.3z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8 73.3l15.8 21.8 12.1-8.8-15.8-21.8-12.1-3.9v12.7zm-15-46.1L26.9 5.4l-12.1 8.8L30.6 36l12.2 3.9V27.2z",
    fill: "#00F2E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 36L5 27.7.4 41.9 26 50.3l12.1-4L30.6 36zm31.8 18.2l7.5 10.3 25.6 8.3 4.6-14.2-25.6-8.3-12.1 3.9z",
    fill: "#00B9F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 50.3l25.6-8.4-4.6-14.2L69.9 36l-7.5 10.3 12.1 4zm-48.5 0L.4 58.6 5 72.8l25.6-8.3 7.5-10.3L26 50.3z",
    fill: "#D63AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6 64.5L14.8 86.3l12.1 8.8 15.9-21.8V60.6l-12.2 3.9zM69.9 36l15.8-21.8-12.1-8.8-15.8 21.8v12.7L69.9 36z",
    fill: "#FB015B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwt);
export default __webpack_public_path__ + "static/media/jwt.2c82c75cf72804213400a1218f85c756.svg";
export { ForwardRef as ReactComponent };